
<div class="user-avatar-container">
  <img v-if="user && userPicture" alt="avatar" :class="'size-' + size" :src="userPicture" />
  <div v-else class="image-placeholder" :class="[`background-color-${colors[colorIndex]}`, 'size-' + size]">
    <span>{{ initials }}</span>
  </div>
</div>
